import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handlePostWithResult } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';
import PaymentMethodFormControl from '../../../../common/inputfields/PaymentMethodFormControl';

class NewRestrain extends Component {

    componentDidMount() {
        console.log(this.props);
    }

    state = {
        newAgain: false,
        selectedRestrainPartner: {},
        selectedPaymentMethod: enums.outPaymentMethods[1],
        selectedEmployee: this.getInitialEmployee(),
        selectedSalary: this.getInitialSalary(),
        amount: '',
        employeeDropDown: (this.props.row && this.props.row.rowType === 'SALARY') ? true : false,
        salaryDropDown: true,
        restrainPartnerDropDrown: (this.props.row && this.props.row.rowType === 'SALARY') ? false : true,
        comment: '',
        errors: new Map(),
    }

    getInitialEmployee() {
        if (this.props.row && this.props.row.rowType === 'SALARY') {
            return { value: this.props.row.employeeId, label: this.props.row.employeeName };
        } else {
            return {};
        }
    }

    getInitialSalary() {
        if (this.props.row && this.props.row.rowType === 'SALARY') {
            return { value: this.props.row.privateId, label: this.props.row.year + '-' + this.props.row.month };
        } else {
            return {};
        }
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedRestrainPartner: {},
            selectedPaymentMethod: enums.outPaymentMethods[1],
            selectedEmployee: {},
            selectedSalary: {},
            amount: '',
            employeeRelatedDropDown: false,
            salaryDropDown: false,
            restrainPartnerDropDrown: false,
            comment: ''
        })
    }
    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/restrain';
        const requestObject = {
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "amount": util.toNumber(this.state.amount),
            "comment": this.state.comment,
            "salaryId": this.state.selectedSalary.value,
            "restrainPartnerId": this.state.selectedRestrainPartner.value,
        };
        handlePost(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        let b = true;
        if (v) {
            b = false;
        }
        this.setState({ selectedEmployee: v, salaryDropDown: b, restrainPartnerDropDrown: b, selectedSalary: {}, selectedRestrainPartner: {} })
    }

    promiseSalaryOptions = async () => {
        const path = '/api/salaries';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value
        };
        const response = await axios.post(path, requestObject);
        const renamedSalaries = [];
        response.data.map((salary) =>
            renamedSalaries.push({
                label: salary.year + '-' + salary.month,
                value: salary.privateId,
            }));
        console.log(renamedSalaries);
        return renamedSalaries;
    }

    promiseRestrainPartnerOptions = async () => {
        const path = '/api/restrainpartners';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value
        };
        const response = await axios.post(path, requestObject);
        const renamedRestrainPartners = [];
        response.data.map((restrainPartner) =>
            renamedRestrainPartners.push({
                label: this.getLabelForRestrainPartner(restrainPartner.name, restrainPartner.comment),
                value: restrainPartner.privateId,
            }));
        return renamedRestrainPartners;
    }

    getLabelForRestrainPartner = (name, comment) => {
        if (comment) {
            return name + "(" + comment + ")";
        } else {
            return name;
        }
    }

    handleRestrainPartnerSelected = (e, v) => {
        if (v && v.inputValue) {
            //new restrainpartner
            const path = '/api/restrainpartner';
            const requestObject = {
                "employeeId": this.state.selectedEmployee.value,
                "name": v.inputValue
            };
            handlePostWithResult(path, requestObject, (res) => this.handleSuccessNewRestrainPartner(v, res.privateId), this);
        } else {
            this.setState({ selectedRestrainPartner: v })
        }
    }

    handleSuccessNewRestrainPartner = (v, id) => {
        let newRestrainPartner = {
            label: v.inputValue,
            value: id,
        }
        this.setState({ selectedRestrainPartner: newRestrainPartner })
        v.label = v.inputValue;
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            disabled={this.state.employeeDropDown}
                            value={this.state.selectedEmployee}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseSalaryOptions}
                            onChange={(e, v) => this.setState({ selectedSalary: v })}
                            disabled={this.state.salaryDropDown}
                            value={this.state.selectedSalary}
                            label={'Fizetés'}
                        />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseRestrainPartnerOptions}
                            onChange={this.handleRestrainPartnerSelected}
                            disabled={this.state.restrainPartnerDropDrown}
                            value={this.state.selectedRestrainPartner}
                            label={'Letiltás partner'}
                            createLabel={'Új letiltás partner'}
                        />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Letiltás összege"
                            errors={this.state.errors}
                            value={this.state.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Közlemény"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewRestrain);
